<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'}
</script>

<style lang="scss">
  // Import vazir Font
  $vazir-font-path: "~vazir-font/dist/";
  @import "~vazir-font/dist/font-face.css";
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>


<style>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield !important;
  }
  ::-moz-selection { /* Code for Firefox */
    color: #fff;
    background: #00a88e;
  }

  ::selection {
    color: #fff;
    background: #00a88e;
  }
</style>
